import Friend from './img/friendFinder.png';
import Burgers from './img/eatBurgers.png';
import MongoNews from './img/mongoNewsScraper.png';
import ParkSmart from './img/parkSmart.png';
import Remember from './img/rememberMe.png';
import Train from './img/trainScreenshot.png';

export default {
  projects: [
    {
      image: Friend,
      title: 'Friend Finder',
      description: 'Full Stack Web App to help you find your new best friend.',
      ghUrl: 'https://github.com/klleroy/FriendFinder/',
      projUrl: 'https://supervillainfriends.herokuapp.com/'
    },
    {
      image: Burgers,
      title: 'Eat The Burgers',
      description: "Eat-Da-Burger! is a restaurant app that lets users input the names of burgers they'd like to eat.",
      ghUrl: 'https://github.com/klleroy/Eat-Da-Burger',
      projUrl: 'https://eatdaburger206.herokuapp.com/'
    },
    {
      image: MongoNews,
      title: 'Mongo News Scraper',
      description:
        'A web app that lets users view and leave comments on the latest news showcasing our Mongoose and Cheerio skills.',
      ghUrl: 'https://github.com/klleroy/MongoNewsScraper',
      projUrl: 'https://mongonews206.herokuapp.com/'
    },
    {
      image: ParkSmart,
      title: 'Park Smart',
      description:
        'ParkSmart is solving the parking problems of Urban areas one driveway at a time.',
      ghUrl: 'https://github.com/klleroy/ParkSmart',
      projUrl: 'https://parksmart206.herokuapp.com/'
    },
    {
      image: Remember,
      title: 'Remember Me',
      description:
        "React Application - Click on an image to earn points, but don't click on any more than once!",
      ghUrl: 'https://github.com/klleroy/remember-me',
      projUrl: 'https://klleroy.github.io/remember-me/'
    },
    {
      image: Train,
      title: 'Train Scheduler',
      description:
        'Scheduling App for fictional Trains utilizing the JavaScript Library moment.js to calculate various moments in time. The purpose of this is to showcase the mathmatical power of JS.',
      ghUrl: 'https://github.com/klleroy/TrainScheduler',
      projUrl: 'https://klleroy.github.io/TrainScheduler'
    }
  ]
};
